<template>
    <div class="QCCampaignList">
        <!--Header-->
        <div class="d-flex align-center justify-space-between header-page">
            <div class="page-title">{{ $f.tc('QcCampaignList') }}
                <v-icon color="#96ADD0" size="26" class="icon-refresh" @click="refresh()">refresh</v-icon>
            </div>
        </div>
        <!--table list qc campaign-->
        <v-container fluid class="fci-scrollbar"
                     style="padding: 20px !important; height: calc(100vh - 129px); overflow-y: auto">
            <v-layout align-center justify-space-between row wrap class="header-table">
                <v-layout>
                    <div style="width: 320px;">
                        <SearchQCCampaign
                            :placeholder="'searchName'"
                            :keyword="filter.search"
                            @input="searchNow($event)"
                            @campaign-selected="viewQCCampaign($event)"
                            class="search-custom">
                        </SearchQCCampaign>
                    </div>
                    <div style="margin-left: 10px;width: 320px">
                        <v-autocomplete
                            hide-details
                            :placeholder="$f.tc('campaign')"
                            v-model="filter.callCampaignId"
                            :items="campaignList"
                            clearable outlined
                            class="input-custom"
                            @change="refresh(1)"
                            @keypress.enter="refresh(1)"
                            item-value="id"
                            item-text="title"
                        >
                        </v-autocomplete>
                    </div>
                    <div style="margin-left: 10px; width: 200px">
                        <v-select
                            hide-details
                            :placeholder="$f.tc('permission')"
                            v-model="filter.permission"
                            :items="permissionList"
                            clearable outlined
                            class="input-custom"
                            @input="refresh(1)"
                            @keypress.enter="refresh(1)"
                        ></v-select>
                    </div>
                </v-layout>
                <div v-if="isHasCallCampaigns" class="btn-primary" style="padding: 10px" @click="addQCCampaign">
                    <img src="/img/add.svg" alt="icon-add" style="transform: scale(1.2); margin-right: 8px">
                    {{ $f.tc('add') + ' ' + $t('campaign') }}
                </div>
                <v-tooltip v-else bottom>
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-disable-2" style="padding: 10px">
                            <img src="/img/add_grey.svg" alt="icon-add"
                                 style="transform: scale(1.2); margin-right: 8px">
                            {{ $f.tc('add') + ' ' + $t('campaign') }}
                        </div>
                    </template>
                    <span>{{ $f.tc('notHasCallCampaigns') }}</span>
                </v-tooltip>

            </v-layout>
            <DataTableCustom
                :headers="headers"
                :items="items"
                :current-page="pagination.page"
                :total-page="totalPage"
                :items-per-page="pagination.rowsPerPage"
                :total-items="totalItems"
                @page-change="(newPage) => handlePageChange(newPage)"
                @item-per-page-change="updateItemsPerPage"
                @row-click="viewQCCampaign($event)"
                style="position: relative"
            >
                <template v-slot:action="props">
                <span class="row-actions">
                    <!--Button Assign Permission-->
                    <v-tooltip top class="mr-6">
                        <template v-slot:activator="{on}">
                            <v-btn icon small class="mx-0" v-if="canEditQCCampaign(props.item.permission)"
                                   @click.stop=" openManagePermissionEditor(props.item)" v-on="on">
                                    <img src="/img/assign-new.svg" alt="icon-permission" style="transform: scale(0.9)">
                            </v-btn>
                        </template>
                        <span>{{ $f.tc('grantPermissions') }}</span>
                    </v-tooltip>
                    <!--Button Edit Campaign-->
                    <v-tooltip top class="mr-6">
                        <template v-slot:activator="{on}">
                            <v-btn icon small class="mx-0" v-if="canEditQCCampaign(props.item.permission)"
                                   @click.stop="addQCCampaign(props.item)" v-on="on">
                            <img src="/img/edit-2.svg" alt="icon-edit" style="transform: scale(0.9);">
                            </v-btn>
                        </template>
                        <span>{{ $f.tc('edit') }}</span>
                    </v-tooltip>
                    <!--Button Download Template Campaign-->
                    <v-tooltip top class="mr-6">
                        <template v-slot:activator="{on}">
                            <v-btn icon small class="mx-0" v-if="canEditQCCampaign(props.item.permission)" v-on="on"
                                   @click.stop="downloadTemplateCampaign(props.item)">
                                    <img src="/img/download.svg" alt="icon-edit" style="transform: scale(0.9);">
                            </v-btn>
                        </template>
                        <span>{{ $f.tc('downloadTemplateQc') }}</span>
                    </v-tooltip>
                    <!--Button Delete Campaign-->
                    <v-tooltip top class="mr-6">
                        <template v-slot:activator="{on}">
                            <v-btn icon small class="mx-0" v-if="isAdminQCCampaign(props.item.permission)"
                                   @click.stop="deleteItem(props.item)" v-on="on">
                            <img src="/img/delete-new.svg" alt="icon-delete" style="transform: scale(0.9);">
                            </v-btn>
                        </template>
                        <span>{{ $f.tc('delete') }}</span>
                    </v-tooltip>
                </span>
                </template>
            </DataTableCustom>
        </v-container>
        <QCPermissionEditor ref="QCPermissionEditor"></QCPermissionEditor>
        <QCCampaignCreator ref="QCCampaignCreator"></QCCampaignCreator>
    </div>
</template>
<script>
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import QCPermissionEditor from '@/views/QualityControl/Dialog/QCPermissionEditor'
import QcCampaignService from '@/services/qc.campaign.service'
import SearchQCCampaign from '@/views/QualityControl/SearchQCCampaign'
import QCCampaignCreator from '@/views/QualityControl/Dialog/QCCampaignCreator'
import DataTableCustom from '@/components/DataTableCustom'
import $utils from '@/utils/utils'
import lodash from 'lodash'
import CampaignService from '@/services/campaign.service'
import {mapState} from 'vuex'

export default {
    name: 'QCCampaignList',
    mixins: [RoleMixin],
    components: {
        QCCampaignCreator,
        QCPermissionEditor,
        DataTableCustom,
        SearchQCCampaign
    },
    data() {
        return {
            permissionList: this.$const.QCCampaign.permissionList,
            filter: {
                search: '',
                permission: '',
                callCampaignId: ''
            },
            items: [],
            pagination: {
                page: 1,
                rowsPerPage: 10,
            },
            totalItems: 0,
            totalPage: 1
        }
    },
    computed: {
        ...mapState({
            isHasCallCampaigns: state => state.qccampaign.callCampaigns.length > 0,
            campaignList: state => state.qccampaign.callCampaigns
        }),
        headers() {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'name'
                },
                {
                    text: this.$t('campaign'),
                    value: 'call_campaign_name'
                },
                {
                    text: this.$t('numberOfBatches'),
                    value: 'number_of_batches'
                },
                {
                    text: this.$t('owner'),
                    value: 'created_by'
                },
                {
                    text: this.$t('permission'),
                    value: 'permission'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom'
                }
            ])
        }
    },
    mounted() {
        this.validateQueryURL()
        this.updateFilterByQuery()
        this.loadData()
    },
    methods: {
        getListCampaigns() {
            return this.$store.dispatch(this.$actionTypes.qccampaign.UPDATE_CALL_CAMPAIGNS)
        },
        openManagePermissionEditor(QCCampaign) {
            this.$refs.QCPermissionEditor.open(QCCampaign)
        },
        updateItemsPerPage(newValue) {
            this.pagination.rowsPerPage = newValue
            this.refresh()
        },
        loadData() {
            this.$appService.showLoading()
            Promise
                .all([this.refresh(this.pagination.page, false), this.getListCampaigns()])
                .finally(this.$appService.hideLoading)
        },
        refresh(pager, showLoading = true) {
            if (pager) {
                this.pagination.page = pager
            }
            if (showLoading) {
                this.$appService.showLoading()
            }
            this.$appService.showLoading()
            return QcCampaignService.getQCCampaigns(
                this.pagination.rowsPerPage,
                this.pagination.page,
                'name',
                this.filter.search,
                this.filter.permission,
                this.filter.callCampaignId
            ).then(
                result => {
                    this.items = result.data.data
                    this.totalItems = result.data.count
                    this.totalPage = Math.ceil(this.totalItems / this.pagination.rowsPerPage)
                }
            ).finally(() => {
                if (showLoading) {
                    this.$appService.hideLoading()
                }
            })
        },
        searchNow(keyword) {
            this.filter.search = keyword
            this.refresh(1)
        },
        handlePageChange(newPage = 1) {
            let crrQuery = this.$utils.cloneObject(this.$route.query)
            if (newPage !== 1) {
                crrQuery.page = newPage
            } else {
                delete crrQuery.page
            }
            this.$router.replace({
                query: crrQuery
            })
            this.refresh(newPage)
        },
        deleteItem(item) {
            this.$appService.confirm(this.$f.tc('confirmDelete', {item: item.title})).then(
                () => {
                    const i18n = {
                        action: this.$f.tc('delete'),
                        item: this.$t('campaign')
                    }
                    QcCampaignService.deleteQCCampaign(item).then(
                        () => {
                            this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, null)
                            this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                            this.refresh()
                        }
                    )
                }
            )
        },
        viewQCCampaign(campaign) {
            this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, campaign)
            this.$store.dispatch(this.$actionTypes.qccampaign.DATA_INPUT_SUGGESTION, campaign.id)
            this.$router.push('/qc-campaign/' + campaign.id)
        },
        addQCCampaign(item) {
            if (item.id) {
                this.$store.commit(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, item)
            }

            this.$refs.QCCampaignCreator.open(item)
        },
        downloadTemplateCampaign(item) {
            if (!item) {
                return
            }

            let model = {
                campaign: {
                    criteria: item.criteria,
                    asr_criteria: item.asr_criteria,
                    data_input: item.data_input,
                }
            }
            $utils.downloadJSON(model, item.name + ' - qc_campaign')
        },
        validateQueryURL() {
            let query = this.$utils.cloneObject(this.$route.query)
            let allow_queries = ['search', 'callCampaignId', 'permission', 'page']
            let keys = Object.keys(query)
            keys.forEach(key => {
                if (!allow_queries.includes(key)) {
                    delete query[key]
                }
            })
            if (!lodash.isEqual(query, this.$route.query)) {
                this.$router.replace({
                    query: query
                })
            }
        },
        updateFilterByQuery() {
            let query = this.$utils.cloneObject(this.$route.query)
            if (Object.keys(query).length > 0) {
                this.pagination.page = query.page ? +query.page : 1
                delete query.page
                this.filter = {...this.filter, ...query}
            }
        }
    },
    watch: {
        filter: {
            deep: true,
            handler: function (newFilter) {
                let query = this.$utils.cloneObject(this.$route.query)
                query = {...query, ...newFilter}
                if (!query.search) {
                    delete query.search
                }
                if (!query.callCampaignId) {
                    delete query.callCampaignId
                }
                if (!query.permission) {
                    delete query.permission
                }
                this.$router.replace({
                    query: query
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.header-table {
    border: 1px solid #DADFEC;
    border-bottom: none;
    padding: 10px;
    gap: 10px;
    background: #FFFFFF;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.icon-refresh {
    cursor: pointer;
}


.title-chart {
    line-height: 30px;
    height: 30px;
    font-size: 16px;
    font-weight: 700;
}

::v-deep {
    .v-menu {
        display: none !important;
    }

    .v-input__slot {
        background: #FFFFFF;
        padding: 0 10px !important;
        border-radius: 0 !important;
        border: 1px solid #D9D9D9;
        font-size: 14px !important;
        height: 36px;
    }

    .v-input__slot:after {
        border: none !important;
    }

    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: none !important;
    }

    .v-input.v-text-field .v-label--active {
        background: #FFFFFF !important;
        top: 8px !important;
        left: -3px !important;
        padding: 0 4px;
        color: #617CA5 !important;
        font-size: 11px !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field .v-input__append-inner {
        margin-top: 4px !important;
    }

    .pager-wrap {
        border-top: 1px solid #DADFEC !important;
    }

    .v-datatable__progress {
        display: none;
    }
}
</style>
